<template>
    <transition name="fade">
        <div id="swiper-container" class="swiper-container slider-center"
             :class="[handbookview || (panelView || panelImage) ? 'handbookheight':'stepheight']">

            <div v-show="handbookview" class="handbook handbookheight handbookwidth">
                <v-btn icon style="position: absolute; top: .5em; right: .5em" @click="closeHandBook">
                    <LATIcon icon="times" :color="$colors.sky_blue_1"/>
                </v-btn>
                <div class="handbookflexcontainer">
                    <v-btn style="align-self: start; margin-bottom: 1em" color="error" x-small @click="goBackToProcedureList">End
                        procedure
                    </v-btn>
                    <h3 class="procedure_title">Procedure: {{ title }}</h3>
                    <Handbook ref="handbook" :procedure="procedure" class="handbook_content" :triggerScroll="triggerScroll" @start-from-step="startFromStep"/>
                    <template v-for="idx in [0,1]">
                        <div v-bind:key="`learn_exam_btns_container${idx}`"
                             :class="{learn_exam_btns_container: true, learn_exam_btns_absolute: idx===1}"
                             v-if="!teacher.isLearning">
                            <v-btn
                                color="primary"
                                @click="chooseMode('guide')"
                            >Learn Procedure
                            </v-btn>
                            <v-btn
                                color="primary"
                                @click="chooseMode('exam')"
                            >Start Exam
                            </v-btn>
                        </div>
                    </template>
                </div>
            </div>
            <div v-show="handbookview" class="handbook handbookwidth handbookheight">
                <Handbook :procedure="procedure" :teacher="teacher"/>
            </div>


            <div v-show="!handbookview"
                 :style="`border: 5px solid ${borderColor}`"
                 style="overflow: hidden"
                 :class="[panelView || panelImage ? 'handbookheight':'stepheight']"
                 class="swiper handbookwidth">


                <div v-if="panelView" style="overflow:hidden;">
                    <div style="height: 60vh; display: flex;">
                        <div
                            style="display: flex; flex-direction: column; height: 100%; flex: 1; align-items: center; justify-content: center">
                            <span style="font-weight: bold; text-transform: uppercase">{{ panelView.message }}</span>
                            <span v-html="panelView.todo"></span>
                        </div>
                    </div>
                </div>

                <div v-if="panelImage" style="overflow:hidden;">
                    <v-img :src="panelImage" contain style="max-height: 60vh"/>
                </div>


                <div style="position: absolute; bottom: 0;" :style="`${panelView || panelImage?'background:white':''}`">
                    <swiper
                        ref="swiper" class="swiper stepheight handbookwidth" :options="swiperOption">
                        <swiper-slide v-for="(step, idx) in steps" v-bind:key="`step_${idx}`" class="swiper-slide">
                            <div class="step-content">
                                <template v-if="teacher.isBlindExam()">
                                    <div
                                        style="height: 100px; width: 100px; display: flex; align-items: center; justify-content: center; padding-left: 5px">
                                        <v-avatar width="90" height="90" style="height: 90px; width: 90px;"
                                                  v-text="(step.stepIdx + 1)" color="white">
                                            {{ step.stepIdx + 1 }}
                                        </v-avatar>
                                    </div>
                                </template>
                                <template v-else>
                                    <v-img
                                        :style="`border-radius:15px; padding:0; margin: auto 1em;cursor:pointer;opacity: ${showStepImg?1:0}`"
                                        contain
                                        rounded
                                        height="100"
                                        width="100"
                                        :src="stepImg(step)"
                                        v-ripple="true"
                                        @click="togglePanelImage(step)"
                                    />
                                </template>
                                <transition name="bounce">
                                    <div class="thumb-icons thumb-up"
                                         v-if="teacher.mode === 'exam' && !showStepImg && isAnswerCorrect">
                                        <LATIcon icon="thumbs-up" style="height: 60px; width: 60px"/>
                                    </div>
                                    <div class="thumb-icons thumb-down"
                                         v-if="teacher.mode === 'exam' && !showStepImg && !isAnswerCorrect">
                                        <LATIcon icon="thumbs-down" style="height: 60px; width: 60px"/>
                                    </div>
                                </transition>

                                <div style="text-align: left; padding: .5em;">

                                    <template
                                        v-if="hideStepTextInBlindExam && teacher.isBlindExam() && !isAnswerCorrect">
                                        <div style="color: #717171; font-size: 80%">Blind exam running. Please touch the
                                            correct cockpit interface in 3D space
                                        </div>

                                    </template>

                                    <template v-else>

                                        <StepText
                                            :step="teacher.isBlindExam() && isAnswerCorrect ? getPrevStep(step) : step"
                                            @toggle-panel="togglePanelView(step)"/>
                                    </template>

                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="swiper-slide" style="flex-direction: row; justify-content: center">
                            <v-btn
                                class="ma-2 white--text btn-size"
                                @click="repeatSlideShow"
                                color="primary"
                            >Repeat Procedure
                            </v-btn
                            >
                            <v-btn
                                v-if="!isExamMode"
                                color="primary"
                                class="ma-2 white--text btn-size"
                                @click="retryAsExam"
                            >Start Exam
                                <GraduationIcon :completed="false" :hideCheckmark="true" color="white"
                                                style="margin-left: 4px;"/>
                            </v-btn
                            >
                            <v-btn
                                v-if="isExamMode && !isCurrenProcedureCompleted"
                                color="primary"
                                class="ma-2 white--text btn-size"
                                @click="setAsCompleted"
                            >
                                Mark Completed
                                <GraduationIcon :completed="true" color="white" style="margin-left: 4px;"/>
                            </v-btn>
                            <v-btn
                                v-if="hasNextProcedure"
                                color="primary"
                                class="ma-2 white--text btn-size"
                                @click="goToNextProcedure"
                            >
                                Next Procedure
                            </v-btn>
                            <v-btn
                                v-else
                                color="#0D47A1"
                                class="ma-2 white--text btn-size"
                                @click="closeSlider">
                                Close
                            </v-btn>
                        </swiper-slide>
                    </swiper>

                    <v-btn icon style="position: absolute; top: 1em; right: 1em; z-index: 10000000"
                           @click="toggleHandbookView('open')">
                        <LATIcon icon="book-open" style="color: #2c3e50"/>
                    </v-btn>

                    <div v-if="showButtons">
                        <!--                   re-add to div below    v-if="!this.teacher.isExamMode()"-->
                        <div
                            style="position: absolute; bottom: .5em; right: 1em; z-index: 10000000; display: flex; flex-direction: column">
                            <v-btn :color="primaryLight" :disabled="prevDisabled" @click="changeSlide('prev')"
                                   style="margin-bottom: 1em; padding: 0 2em">
                                prev
                            </v-btn>
                            <v-btn :disabled="nextDisabled" color="primary"
                                   @click="changeSlide('next')">
                                next
                            </v-btn>
                        </div>
                    </div>

                </div>


            </div>


        </div>
    </transition>
</template>

<script>
import * as THREE from "three";
import "../styles/frontend/swiper.css";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import {aircraftConfig, settings} from "../config";
import {LATEventBus} from "../modules/LAT/LAT_main";
import Handbook from "./Handbook";
import GraduationIcon from "./Icon/GraduationIcon";
import {procedureTeacher} from "../modules/ProcedureTeacher";
import LATIcon from "./Icon/LATIcon";
import StepText from "./StepText";

export default {
    name: "swiper-example-vertical",
    title: "Vertical slider",
    components: {
        StepText,
        LATIcon,
        GraduationIcon,
        Handbook,
        swiper,
        swiperSlide
    },
    props: ['teacher', 'is_next', 'hideStepTextInBlindExam', 'handbookview'],
    $emits: ['next-procedure', 'screen-switch', 'sliderSwitch', 'toggleHandbook'],
    computed: {
        isExamMode() {
            return this.teacher.isExamMode();
        },
        showButtons() {
            return this.isMounted ? this.steps && this.$refs.swiper.swiper.activeIndex !== this.steps.length : null;
        },
        nextDisabled() {
            if (this.isMounted) {
                return this.teacher.isExamMode() || this.steps && this.$refs.swiper.swiper.activeIndex === this.steps.length
            } else {
                return null
            }
        },
        prevDisabled() {
            if (this.isMounted) {
                return this.$refs.swiper.swiper.activeIndex === 0
            } else {
                return null
            }
        },
        steps() {
            return this.teacher ? this.teacher.getSteps() : [];
        },
        procedure() {
            return this.teacher ? this.teacher.activeProcedure : null
        },
        title() {
            return this.procedure ? this.procedure.name : 'No procedure to display';
        },
        stepImg() {
            // disabled get button image from step since its missing from api
            // return (step) => (step.points && step.points.length) ? this.aircraftConfig.getButton(step.points[0].btn) : '/';
            return (step) => step.spot.state_image
        },
        isCurrenProcedureCompleted() {
            return this.$store.state.completed_procedures.find(p => p.procedure === this.teacher.activeProcedure.name)
        },
        borderColor() {
            return settings.MARKER_LINE_COLOR
        },
        hasNextProcedure() {
            return this.findNextIfExists();
        }
    },
    mounted() {
        this.isMounted = true;
        LATEventBus.$on('correct_step_clicked', this.onCorrectStepClick)
        LATEventBus.$on('wrong_step_clicked', this.onWrongStepClick)

        this.updatePositionInteravel = setInterval(() => this.updatePosition(), 50)
        window.addEventListener('keydown', this.handleKeyDown.bind(this))

        // setTimeout(()=>{
        //   this.handbookview = !this.handbookview
        // }, 2000)

        if(this.teacher){
            this.teacher.handbookOpen = true;
        }
    },
    unmounted() {
        window.removeEventListener('keydown', this.handleKeyDown)
        if(this.teacher){
            this.teacher.handbookOpen = true;
        }
    },
    beforeDestroy() {
        LATEventBus.$off('correct_step_clicked', this.onCorrectStepClick)
        LATEventBus.$off('wrong_step_clicked', this.onWrongStepClick)
        clearInterval(this.updatePositionInteravel)
    },
    data() {

        const defaultsAtProcedureStart = {
            showStepImg: true,
            isAnswerCorrect: false,
            closeHandBookVisible: false,
            panelView: null,
            panelImage: null,
            showSolution: false,
            triggerScroll: false
        }

        return {
            primaryLight: '#fccb5d',
            step: null,
            isMounted: false,
            aircraftConfig: aircraftConfig,
            defaultsAtProcedureStart,
            ...defaultsAtProcedureStart,
            position: [0, 0],
            swiperOption: {
                direction: "vertical",
                inverse: true,
                // allowSlideNext: !this.teacher.isExamMode(),
                allowSlideNext: true,
                allowTouchMove: false,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                on: {
                    init: () => {
                        this.teacher.setStep(0);
                    },

                    slideChange: () => {
                        const slideIdx = this.$refs.swiper.swiper.activeIndex;
                        let steps = this.steps;
                        if (!steps || slideIdx >= steps.length) return;

                        this.teacher.setStep(slideIdx);
                        this.step = this.teacher.step;
                    }
                },
            },
        };
    },
    methods: {
        handleKeyDown(e) {
            if (!this.handbookview && !this.nextDisabled && this.$refs && this.$refs.swiper && this.$refs.swiper.swiper) {
                const key = e.key;
                switch (key) {
                    case 'ArrowLeft' :
                        this.changeSlide('prev');
                        break;
                    case 'ArrowRight' :
                        this.changeSlide('next');
                        break;
                    case 'ArrowDown' :
                        this.changeSlide('prev');
                        break;
                    case 'ArrowUp':
                        this.changeSlide('next');
                        break;
                }
            }
        },
        closeHandBook() {
            if (this.teacher.isLearning) {
                this.$emit('toggleHandbook', false)
            } else {
                this.closeSlider()
            }
        },
        togglePanelView(step) {
            if (!step || this.panelView) {
                this.panelView = null;
            } else {
                this.panelView = step;
            }
        },
        togglePanelImage(step) {
            if (!step || this.panelImage) {
                this.panelImage = null;
            } else {
                this.panelImage = step.spot.state_image;
            }
        },
        toggleHandbookView(mode) {
            this.togglePanelView(null)
            this.$emit('toggleHandbook', mode === 'open') ;
            mode === 'open' ? this.closeHandBookVisible = true : this.closeHandBookVisible = false;
            mode === 'open' ? this.triggerScroll = true : this.triggerScroll = false
            if (mode === 'open') {
                this.$refs.handbook.updatePageAndScrollDelayed();
            }
            if(this.teacher){
                this.teacher.handbookOpen = mode === 'open';
            }
        },
        changeSlide(mode) {
            this.togglePanelView(null)
            mode === 'next' ? this.$refs.swiper.swiper.slideNext() : this.$refs.swiper.swiper.slidePrev();
            const activeIdx = this.$refs.swiper.swiper.activeIndex;
        },
        chooseMode(mode) {
            this.togglePanelView(null)
            this.togglePanelView(null)
            this.$emit('toggleHandbook', false)
            this.teacher.setMode(mode)
            this.teacher.isLearning = true;
            this.teacher.setStep(0);
            this.teacher.handbookOpen = false;
            // this.$refs.swiper.swiper.allowSlideNext = !this.teacher.isExamMode()
        },
        async goBackToProcedureList(){
            await this.teacher.endProcedure();
            await this.teacher.setLineSource2D(null)
            await this.$emit('screen-switch', {value: true, procedure: null})
        },
        closeSlider: async function () {
            await this.teacher.endProcedure();
            await this.teacher.setLineSource2D(null)
            await this.$emit("sliderSwitch", false);
        },
        repeatSlideShow() {
            this.$refs.swiper.swiper.slideTo(0, 0, false) // will call setStep on teacher due to event
        },
        async goToNextProcedure() {
            const nextProcedure = this.findNextIfExists();
            if (nextProcedure) {
                this.teacher.isLearning = false;
                this.$emit('next-procedure',nextProcedure)
            }
        },
        findNextIfExists() {
            const currentProcedure = this.teacher.activeProcedure;
            const index = aircraftConfig.procedures.indexOf(currentProcedure)
            return aircraftConfig.procedures[index + 1] || null;
        },
        retryAsExam() {
            this.chooseMode('exam')
            this.repeatSlideShow()
        },
        setAsCompleted() {
            this.$store.dispatch('addCompletedProcedure', {
                aircraft: this.aircraftConfig.selected,
                procedure: this.teacher.activeProcedure.name
            })
            this.$toast.success('Saved as completed! 👌')
        },
        getPos() {
            const left = this.$refs.swiper.$el.getBoundingClientRect().left
            const top = this.$refs.swiper.$el.getBoundingClientRect().top
            const height = this.$refs.swiper.$el.offsetHeight;
            const width = this.$refs.swiper.$el.offsetWidth;
            return [left, top, height, width]
        },
        updatePosition() {
            const newPos = this.getPos();
            if (newPos[0] !== this.position[0] || newPos[1] !== this.position[1]) {
                this.position = newPos
                this.teacher.setLineSource2D(...this.position)
            }
        },
        onCorrectStepClick() {

            if (this.teacher.isExamMode()) {

                this.showStepImg = false
                this.isAnswerCorrect = true

                this.$refs.swiper.swiper.allowSlideNext = true
                this.$refs.swiper.swiper.slideTo(this.$refs.swiper.swiper.activeIndex + 1, 0, false)
                this.$refs.swiper.swiper.allowSlideNext = !this.teacher.isExamMode()

                setTimeout(() => {
                    this.showStepImg = true
                    this.isAnswerCorrect = false

                }, settings.ANIMATION_TIME_THUMB_UP_DOWN)

            } else {
                this.$refs.swiper.swiper.slideTo(this.$refs.swiper.swiper.activeIndex + 1, 0, false)
            }
        },
        onWrongStepClick() {

            if (this.teacher.isExamMode()) {
                this.showStepImg = false
                this.isAnswerCorrect = false

                setTimeout(() => {
                    this.showStepImg = true
                    this.isAnswerCorrect = false
                }, settings.ANIMATION_TIME_THUMB_UP_DOWN)
            }

        },

        getPrevStep(sourceStep) {
            if (sourceStep.stepIdx === 0) return sourceStep;
            return this.steps.filter(step => step.stepIdx === sourceStep.stepIdx - 1)[0]
        },
        startFromStep(stepIdx){
            this.chooseMode('guide')
            this.$refs.swiper.swiper.slideTo(stepIdx, 0, false)
        }
    }
};
</script>

<style scoped lang="less">

@import "../assets/lufthansacolors";
@step-content-height: 150px;


.btn-disabled {
    color: rgba(223, 223, 223, 0.9)
}

.btn-size {
    width: max-content;
    height: 50px !important;
    margin-left: 2% !important;
    margin-right: 2% !important;
}

.handbookbtn {
    width: 170px !important;
    padding: 0 1.5em
}


.step-content {
    display: flex;
    height: @step-content-height;
    // width is calculated because of buttons at right
    max-width: -webkit-calc(100% - 110px);
    max-width:    -moz-calc(100% - 110px);
    max-width:         calc(100% - 110px);
    overflow:hidden;
}

/* Small only */
@media screen and (max-width: 599px) {

    .step-content {
        flex-direction: column;
    }
}

/* correct/wrong answer animation */

.bounce-enter-active {
    animation: bounce-in 0.5s;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.25);
    }
    100% {
        transform: scale(1);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.handbookwidth {

    width: 70vw;
    @media screen and (max-width: 599px) {
        width: 100vw;
    }
    @media screen and (min-width: 600px) and (max-width: 1264px) {
        width: 70vw;
    }
}


.handbookwidthMinusTab {

    width: 67vw;
    @media screen and (max-width: 599px) {
        width: 97vw;
    }
    @media screen and (min-width: 600px) and (max-width: 1264px) {
        width: 67vw;
    }
}

.handbook {
    margin-left: auto;
    padding: 1em;
    position: relative;
    margin-bottom: 1em;
    background-color: white;
}

.handbookheight {
    height: 90vh;
    top: 10px;
}


.handbookflexcontainer {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.handbook_content {
    flex: 1;
    background-color: white;
    overflow: hidden;
}

.procedure_title {
    color: @lh-skyblue1;
    text-shadow: 1px 1px rgba(152, 148, 255, 0.07);
    margin-left: 1pt;
    font-size: 20pt;
    text-align: left;
    display: flex;
    flex: 0;
}

.learn_exam_btns_container {
    display: flex;
    flex-grow: 0;
    justify-content: space-around;
    align-items: center;
    /*background-color: rgba(175, 145, 86, 0.99);*/
    margin-top: 1em;
    width: 100%;
    height: 50px;
}

.learn_exam_btns_absolute {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: white;
    height: 83px;
    margin: 0px 16px 0px 16px;
    padding-right: 32px;
}

.thumb-icons {
    height: 100px;
    width: 100px;
    margin: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    position: absolute;
}

.thumb-up {
    color: mediumseagreen;
}

.thumb-down {
    color: orangered;
}

.swiper {
    margin-left: auto;
    position: relative;
}

.swiper-button-prev, .swiper-button-next {
    color: #0D47A1;
}

.stepheight {

    height: 20vh;
    min-height: @step-content-height;
}

/* centering the slider div in the middle */
.slider-center {
    position: absolute;
    bottom: 15vh;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    border-radius: 8px;
    background-color: rgb(255, 255, 255); /* fallback... */
    background-color: rgba(255, 255, 255, 0.9);
}

.swiper-slide, .step_title {
    display: flex;
    /*flex-direction: column;*/
    /*justify-content: center;*/
    align-items: center;
    /*text-align: center;*/
    font-weight: bold;
    font-size: 20px;
}

.swiper-slide{
    overflow: hidden;
}

.step_title {
    color: rgb(13, 71, 161);
    text-transform: uppercase;
}

</style>
